/******/ (() => { // webpackBootstrap
/*!********************************************************!*\
  !*** ./_build/scripts/snippets/layout-product-form.js ***!
  \********************************************************/
// Read-more toggle — runs unconditionally, independent of custom element state
document.addEventListener('click', (e) => {
  const readMore = e.target.closest('.read-more');
  if (!readMore) return;
  const content = readMore.closest('.details-content')?.querySelector('.read-more-content');
  if (content) {
    content.classList.add('is-visible');
    readMore.classList.add('is-hidden');
  }
});

try {

class LayoutProductForm extends window.Herd.SparkElement() {
  constructor() {
    super();
    this.loadSlider();

    this.form = this.querySelector('form');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
  }

  async onSubmitHandler(e) {
    e.preventDefault();

    const formData = new FormData(e.target);
    const id = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity'));
    const properties = buildProperties(formData);
    await this.addToCart({ id, quantity, properties });
  }

  async addToCart(item, reloadSections = true) {
    try {
      const sections = reloadSections
        ? (window.Herd.utils.sectionRenderer?.popoutCartSections?.map((s) => s.section) ?? [])
        : [];
      const result = await window.Herd.Cart.addItem(
        {
          id: item.id,
          quantity: item.quantity,
          properties: item.properties,
        },
        this.form,
        {
          sections,
          sectionsUrl: window.location.pathname + window.location.search,
        }
      );
      this.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
      return result;
    } catch (err) {
      return this.handleAddToCartError(err, item);
    }
  }

  async handleAddToCartError(err, item) {
    console.log(err, item);
  }

  loadSlider() {
    if (window.theme.Swiper) {
      this.initSlider();
    } else {
      document.addEventListener(
        'theme:inititialised',
        () => {
          this.initSlider();
        },
        { once: true }
      );
    }
  }

  initSlider() {
    const sliderElement = this.querySelector('[data-preferences-slider]');
    const sliderScrollbarElement = this.querySelector('[data-preferences-slider-scrollbar]');

    new window.theme.Swiper(sliderElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      scrollbar: {
        el: sliderScrollbarElement,
        draggable: true,
      },
    });
  }

}

function buildProperties(formData) {
  const propertyKeyValues = [...formData.entries()].filter(
    ([key, value]) => key.includes('properties[') && value !== ''
  );

  function propertyReducer(properties, [key, value]) {
    const strippedKey = key.replace('properties[', '').slice(0, -1);

    return {
      ...properties,
      [strippedKey]: value,
    };
  }

  return propertyKeyValues.reduce(propertyReducer, {});
}

if (!customElements.get('layout-product-form')) {
  customElements.define('layout-product-form', LayoutProductForm);
}

} catch (e) {
  console.warn('layout-product-form custom element could not be defined:', e);
}
/******/ })()
;